import { render, staticRenderFns } from "./PostHeader.vue?vue&type=template&id=5e02b722"
import script from "./PostHeader.vue?vue&type=script&lang=ts"
export * from "./PostHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports